export const Resource = {
  ANNOTATION_CREDIT: 'annotation_credit',
  MANAGER: 'manager',
  WORKER: 'worker',
  WORKSPACE: 'workspace',
  USER: 'user',
  FILE: 'file',
  DICOM_FILE: 'dicom_file',
  PDF_FILE: 'pdf_file',
  VIDEO_FILE: 'video_file',
  MODEL: 'model',
  CONSENSUS_STAGE: 'consensus_stage',
  LOGIC_STAGE: 'logic_stage',
  SAMPLING_STAGE: 'sampling_stage',
  WEBHOOK_STAGE: 'webhook_stage',
  MODEL_STAGE: 'model_stage',
  STORAGE: 'storage',
  STORAGE_INTEGRATION: 'storage_integration',
  SSO_AND_SAML: 'sso_and_saml',
  TFA_ENFORCEMENT: 'tfa_enforcement',
} as const

export type Resource = (typeof Resource)[keyof typeof Resource]

export type CustomerPlan = {
  customer_addon_licenses: CustomerAddonLicense[]
  name: string
  plan_addon_licenses: PlanAddonLicense[]
  plan_licenses: PlanLicense[]
  renewal_datetime: Date
  usage: Usage
  plan_id: string
}

export type CustomerAddonLicense = {
  limit: number
  price: Price
  resource: Resource
}

export type Price = {
  amount: number
  currency: string
}

export type PlanAddonLicense = {
  limit: number
  price: Price
  resource: Resource
}

export type PlanLicense = {
  limit: number
  resource: Resource
  is_blocking: boolean
}

export type Usage = {
  customer_addon_licenses_usage: LicenseUsage[]
  licenses_distribution: LicensesDistribution[]
  plan_licenses_usage: LicenseUsage[]
}

export type LicenseUsage = {
  metadata: UserUsageMetadata | null
  resource: Resource
  usage: number
  limit: number
}

export type UserUsageMetadata = {
  manager_count: number
  worker_count: number
}

export type LicensesDistribution = {
  distribution: { workspace_id: number; count: number }[]
  resource: Resource
}

export const LimitType = {
  SOFT: 'soft',
  HARD: 'hard',
  NONE: 'none',
} as const

export type LimitType = (typeof LimitType)[keyof typeof LimitType]
